import React, { useState, useContext } from "react";
import Im from "immutable";
import {
  FormFields,
  FormMetaFields,
  FormNonFieldErrors,
  registrationFieldProps,
} from "./formItems";
import {
  getRecaptchaSiteKey,
  RecaptchaRow,
  ReloadRecaptcha,
} from "./recaptcha";
import AzureSSOButton, { mustUseAzure } from "./azure";
import { isIP, postFetch, prefixProtocol } from "./utils";
import { AuthContext } from "./context";

export function RegistrationPage(props) {
  return <RegistrationForm />;
}

export default function RegistrationForm(props) {
  const { host, azureConfig, hideMicrosoftSSO } = useContext(AuthContext);
  const { metaFieldProps, initMeta, recaptchaExtra } = props;

  const [errors, setErrors] = useState(null);
  const [metaJSON, setMetaJSON] = useState(initMeta || {});
  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    password1: "",
    password2: "",
    errors: null,
    showRecaptcha: !isIP(window.location.hostname),
  });
  const [recaptchaState, setRecaptcha] = useState(
    isIP(window.location.hostname) ? "localsite" : null,
  );
  const [recaptchaInstance, setRecaptchaInstance] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [email, setEmail] = useState(null);

  const onChange = (e) => {
    if (!e.target) {
      return null;
    }
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const onChangeMeta = (e) => {
    if (!e.target) {
      return null;
    }
    setMetaJSON({
      ...metaJSON,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const gRecaptchaSiteKey = getRecaptchaSiteKey();
    const data = {
      ...state,
      email,
      username: email,
      meta_json: { ...metaJSON },
      gRecaptchaResponse: recaptchaState,
      name: "",
      gRecaptchaSiteKey,
    };

    console.log("Submitting registration form data", host, data);
    postFetch({
      url: `${prefixProtocol(host)}/auth-rest/register/`,
      data,
      onSuccess: (data) => {
        console.log("Registration request success", data);
        setIsRegistered(true);
        setIsActive(data?.is_active);
      },
      onFailure: (data) => {
        console.log("Registration request failed", data);
        setErrors(Im.fromJS(data));
        recaptchaInstance.reset();
      },
    });
  };

  if (isRegistered) {
    if (isActive) {
      return <UserIsActiveBody />;
    }
    return <UserNotActiveBody />;
  }

  if (!email) {
    return (
      <div className="container mt-3">
        <div className="row">
          <div className="col">
            <form
              className="form"
              onSubmit={(e) => {
                e.preventDefault();
                setEmail(e.target[0].value);
              }}
            >
              <input className="form-control" name="email" type="email" placeholder="Email" />
              <button className="btn btn-outline-primary btn-sm mt-2" type="submit">Next</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  if (mustUseAzure({ email })) {
    return (
      <AzureSSOButton
        hide={hideMicrosoftSSO}
        showTopSeparator
        config={{ ...azureConfig, register: true }}
      />
    );
  }

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col">
          <form className="form" onSubmit={onSubmit}>
            <FormNonFieldErrors errors={errors} />
            <FormFields
              fieldProps={registrationFieldProps}
              values={state}
              errors={errors}
              onChangeHandler={onChange}
            />
            <div
              style={{ marginTop: "-1em", marginLeft: "0.25em" }}
              className="form-group"
            >
              <small className="text-muted">
                <b>
                  All passwords must contain at least 12 characters, one
                  uppercase, one special character and one numeric character. It
                  also cannot be similar to parts of your name or email address.
                </b>
              </small>
            </div>
            <FormMetaFields
              fieldProps={metaFieldProps}
              values={metaJSON}
              onChangeHandler={onChangeMeta}
            />
            <RecaptchaRow
              show={true || state.showRecaptcha}
              setRecaptcha={setRecaptcha}
              setRecaptchaInstance={setRecaptchaInstance}
              recaptchaExtra={recaptchaExtra}
            />
            <ReloadRecaptcha
              hide
              setRecaptchaInstance={setRecaptchaInstance}
              recaptchaInstance={recaptchaInstance}
            />
            <RegisterButton gRecaptchaResponse={recaptchaState} />
          </form>
        </div>
        <div className="col">
          <AzureSSOButton
            hide={hideMicrosoftSSO}
            showTopSeparator
            config={{ ...azureConfig, register: true }}
          />
        </div>
      </div>
    </div>
  );
}

function RegisterButton(props) {
  const { gRecaptchaResponse } = props;

  return (
    <div className="form-group">
      <button
        className="btn btn-sm btn-primary btn-block"
        disabled={!gRecaptchaResponse}
        type="submit"
      >
        Register
      </button>
    </div>
  );
}

function UserNotActiveBody() {
  return (
    <div className="container mt-3">
      <p>
        An activation email has been sent. Check your email and click the link
        to verify your email address.
      </p>
      <p>
        <b>
          Please check your junk or spam folder. If you do not receive the
          activation email then please contact support for manual verification
          of your email.
        </b>
      </p>
    </div>
  );
}

function UserIsActiveBody() {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col">
          <p>You can now login directly.</p>
          <button
            className="btn btn-primary btn-sm"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/accounts/login";
            }}
          >
            Log in here
          </button>
        </div>
      </div>
    </div>
  );
}
